<template>
  <CButton 
    :color="color"
    @click="onClick"
    :disabled="delayLoading"
  >
    {{text}}
    <c-spinner
      v-if="delayLoading"
      color="white"
      size="sm"
    />  
  </CButton>
</template>

<script>
export default {
  name: 'LoadingStateButton',
  props: {
    color: {
      default: 'default',
    },
    text: {},
    loading: {
      default: false,
    },
  },
  data() {
    return {
      delayLoading: this.loading,
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  },
  watch: {
    loading (newVal) {
      if (!newVal) {
        if (this.loadingTimeout) clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.delayLoading = newVal
        }, 500)
      } else {
        this.delayLoading = newVal
      }
    }
  }
}
</script>